import React from 'react';
interface QuotationTravellerInfoProps {
  travellers: string[];
  travelDates: string;
  totalNights: number;
  destinations: string[];
  paxCount: string;
}
export function QuotationTravellerInfo({
  travellers,
  travelDates,
  totalNights,
  destinations,
  paxCount
}: QuotationTravellerInfoProps) {
  return <div className="bg-blue-50/50 border border-blue-200 rounded-lg p-5 mb-6" data-id="element-972">
      <div className="grid grid-cols-2 gap-x-8 gap-y-3" data-id="element-973">
        <div data-id="element-974">
          <p className="text-xs font-semibold text-neutral-700 mb-1" data-id="element-975">
            Traveller(s):
          </p>
          <div className="space-y-0.5" data-id="element-976">
            {travellers.map((traveller, index) => <p key={index} className="text-sm text-neutral-900" data-id="element-977">
                {traveller}
              </p>)}
          </div>
        </div>

        <div data-id="element-978">
          <p className="text-xs font-semibold text-neutral-700 mb-1" data-id="element-979">
            Travel Dates:
          </p>
          <p className="text-sm text-neutral-900" data-id="element-980">{travelDates}</p>
        </div>

        <div data-id="element-981">
          <p className="text-xs font-semibold text-neutral-700 mb-1" data-id="element-982">
            Total Nights:
          </p>
          <p className="text-sm text-neutral-900" data-id="element-983">{totalNights} nights</p>
        </div>

        <div data-id="element-984">
          <p className="text-xs font-semibold text-neutral-700 mb-1" data-id="element-985">
            Destination(s):
          </p>
          <p className="text-sm text-neutral-900" data-id="element-986">{destinations.join(', ')}</p>
        </div>

        <div className="col-span-2" data-id="element-987">
          <p className="text-xs font-semibold text-neutral-700 mb-1" data-id="element-988">
            Pax Count:
          </p>
          <p className="text-sm text-neutral-900" data-id="element-989">{paxCount}</p>
        </div>
      </div>
    </div>;
}